//src/cos/index.js
var COS = require('cos-js-sdk-v5');

var cos = new COS({
    SecretId: 'AKIDkImCk2QlIPOQcsEkWF6Exrp1XBsKhCAK',
    SecretKey: 'TApU9g9kjyBWzPoCc4fFkEqfXNKFPThn',
});

var tengxunCos = {
    Bucket: 'polz-files-1302700757',//这边注意了，bucket的名称一定不能用-拼接，cos默认-后面是appId
    Region: 'ap-shanghai',
    iconBaseUrl: "https://polz-files-1302700757.cos.ap-shanghai.myqcloud.com"
}
//签名方法
var autograph = {
    addAutograph(url) {
        if (url) {
            if (url.indexOf('?') == -1 && url.indexOf('polz-files') != -1) {
                let name = url.split('com/')[1];
                //重新签名
                return cos.getObjectUrl({
                    Bucket: tengxunCos.Bucket, /* 填入您自己的存储桶，必须字段 */
                    Region: tengxunCos.Region,  /* 存储桶所在地域，例如ap-beijing，必须字段 */
                    Key: name,  /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */
                })
            } else {
                //    拼接路径
                return tengxunCos.iconBaseUrl + '/' + name
            }
        }
    }
}

export default {
    cos, tengxunCos, autograph
}
